import React, { memo, useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import '../../styles/modals/ConfirmationFeedDeleteModal.css'
import { useTranslation } from 'react-i18next'
import { ReactComponent as ConfirmImage } from '../../assets/svg/ConfirmImage.svg'
import Loading from '../Loading'

const ConfirmationModal = memo(({ modalIsOpen, afterOpenModal, closeModal, confirmation, message, subMessage = '' }) => {
    const { t, locale } = useTranslation()

    const [progress, setProgress] = useState(false)

    useEffect(() => {
        ReactModal.setAppElement('#root')
        if (modalIsOpen) {
            document.getElementById('home').style.filter = 'blur(5px)'
        } else {
            document.getElementById('home').style.filter = 'unset'
        }
    }, [modalIsOpen])

    const submitConfirm = () => {
        confirmation()
        // closeModal();
    }

    return (
        <ReactModal
            isOpen={modalIsOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            contentLabel="Example Modal"
            onAfterClose={() => {
                setProgress(false)
            }}
            style={{
                overlay: {
                    zIndex: 12,
                },
                content: {
                    width: 600,
                    height: 450,
                    padding: 0,
                    opacity: 1,
                    minWidth: 600,
                    margin: 'auto',
                    marginTop: '2%',
                    backgroundColor: 'transparent',
                    maxHeight: '90%',
                    border: 'none',
                    margin: 'auto',
                    boxShadow: 'none',
                    overflow: 'hidden',
                },
            }}
        >
            <div className="bg-background rounded-xl flex flex-col h-full items-center justify-between p-10">
                <p className="text-textDark text-xl font-bold text-center">{message}</p>
                {!!subMessage && <p className="text-textDark text-sm mt-2 text-center">{subMessage}</p>}

                <div className="flex flex-row justify-between items-center w-full mt-6">
                    <div
                        className="bg-deepOcean pointer flex items-center justify-center text-textLight text-base font-semibold rounded-xl w-[250px] h-[55px] transition-all !duration-[250ms] ease-in-out hover:bg-lightMint hover:text-textDark"
                        onClick={() => closeModal()}
                    >
                        {t('cancel')}
                    </div>
                    <button
                        className="border pointer flex items-center justify-center border-deleteRed text-deleteRed text-base font-semibold rounded-xl w-[250px] h-[55px] transition-all !duration-[250ms] ease-in-out hover:bg-deleteRed hover:text-textLight"
                        disabled={progress}
                        onClick={() => {
                            setProgress(true)
                            submitConfirm()
                        }}
                    >
                        {progress ? <Loading /> : 'OK'}
                    </button>
                </div>
            </div>
        </ReactModal>
    )
})

export default ConfirmationModal
